<script lang="ts">
  import { isMobile } from '$src/stores/media.store';
	import HorizontalDraggable from './HorizontalDraggable.svelte';

  export let data: UnderlinedTab.Item[];
  export let activeTab: string = '';
</script>

<HorizontalDraggable>
	<div class="flex flex-row gap-6 {$isMobile && "overflow-x-auto"} whitespace-nowrap">
		{#each data as item}
			<button on:click={() => (activeTab = item.title)} class:selected={activeTab === item.title}>
				{item.title}
				{#if item.badge}
					<span>
						{item.badge}
					</span>
				{/if}
			</button>
		{/each}
	</div>
</HorizontalDraggable>

{#each data as item}
  {#if activeTab === item.title}
    <div class="p-6 whitespace-nowrap">
      <svelte:component this={item.content.component} {...item.content.props} />
    </div>
  {/if}
{/each}

<style type="postcss">
  button {
    @apply flex flex-row items-center h-full;
    @apply gap-1 pb-1;
    @apply text-blueish-grey-400 font-bold;
    @apply border-b-2 border-white;
    @apply ease-out duration-200;
    @apply cursor-pointer;
  }
  button > span {
    @apply bg-blueish-grey-100 w-fit;
    @apply rounded-5 px-2 py-0.5;
    @apply text-sm;
  }
  button.selected {
    @apply text-blueish-grey-900 border-b-2 border-blueish-grey-900;
  }
  button.selected > span {
    @apply text-blueish-grey-900;
  }
</style>
